import React from "react";

interface BreadcrumbProps {
  firstLabel: string; // Label for the list page (e.g., "Organisation", "Department")
  secondLabel?: string; // Full label for the second breadcrumb (e.g., "Edit Organisation", "Add Organisation")
  handleBack: () => void; // Function to handle back navigation
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  firstLabel,
  secondLabel,
  handleBack,
}) => {
  return (
    <div className="text-muted">
      <span
        className="text-muted"
        style={{ fontSize: "0.8rem", cursor: "pointer" }}
        onClick={handleBack}
      >
        {firstLabel}
      </span>{" "}
      &gt;{" "}
      <span className="text-muted" style={{ fontSize: "0.8rem" }}>
        {secondLabel}
      </span>{" "}
    </div>
  );
};

export default Breadcrumb;
